export default "__VITE_ASSET__g5IP9h4L__"